// @flow
// Decoders
import { createDecoder } from 'fc-decoders'
import encoder from './encoder'

// Exports
export default createDecoder(encoder)
